import { ISignupStepRouteResponse } from '@/app/(auth)/signup/components/signupStep/ISignupStepRouteResponse';

export function isSignupRedirect(response: ISignupStepRouteResponse): response is { redirect: string } {
  return 'redirect' in response;
}
